import { Types } from '../actions/taskHistoryActions';
const initialState = {
  loading: true,
  error: '',
  data: [],
};

export const taskHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_TASK_HISTORY_REQUEST: {
      return {
        ...state,
        data: [],
        loading: true,
      };
    }
    case Types.RESET_TASK_HISTORY: {
      return {
        ...initialState,
        loading: false,
      };
    }

    case Types.GET_TASK_HISTORY_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    }
    case Types.SET_ERROR: {
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    }
    default:
      return state;
  }
};
